import { css } from '@linaria/atomic';

export const shortenedUrlWiggleStyles = css`
  /* Atomic Linaria emits @keyframes globally (unscoped), so the name must be unique. */
  @keyframes send-in-thread-shortened-url-wiggle {
    0%,
    100% {
      transform: translateX(var(--fabric-number-n-0));
    }
    20% {
      transform: translateX(var(--fabric-number-n-2-neg));
    }
    50% {
      transform: translateX(var(--fabric-number-n-2));
    }
    80% {
      transform: translateX(var(--fabric-number-n-1-neg));
    }
  }

  animation-name: send-in-thread-shortened-url-wiggle;
  animation-duration: 400ms;
  animation-timing-function: ease-in-out;
`;

export const modalBodyStyles = css`
  margin-top: var(--fabric-space-padding-none);
  margin-right: var(--fabric-space-padding-none);
  margin-bottom: var(--fabric-space-padding-none);
  margin-left: var(--fabric-space-padding-none);
  padding-top: var(--fabric-space-padding-none);
  padding-right: var(--fabric-space-padding-none);
  padding-bottom: var(--fabric-space-padding-none);
  padding-left: var(--fabric-space-padding-none);
`;

export const templateSelectionContainerStyles = css`
  border-top-left-radius: var(--fabric-radius-md);
  border-top-right-radius: var(--fabric-radius-md);
  border-bottom-right-radius: var(--fabric-radius-md);
  border-bottom-left-radius: var(--fabric-radius-md);
  border-width: var(--fabric-number-n-0-25);
  border-style: solid;
  border-color: var(--fabric-color-neutral-20);
  margin-top: var(--fabric-space-padding-md);
  overflow-y: hidden;
`;

export const templateSelectionHeaderStyles = css`
  display: flex;
  align-items: center;
  padding-top: var(--fabric-space-padding-md);
  padding-right: var(--fabric-space-padding-xs);
  padding-bottom: var(--fabric-space-padding-md);
  padding-left: var(--fabric-space-padding-xs);
  row-gap: var(--fabric-space-gap-md);
  column-gap: var(--fabric-space-gap-md);
  border-bottom-width: var(--fabric-number-n-0-25);
  border-bottom-style: solid;
  border-bottom-color: var(--fabric-color-neutral-20);
`;

export const templateSelectorStyles = css`
  padding-top: var(--fabric-space-padding-md);
  padding-right: var(--fabric-space-padding-md);
  padding-bottom: var(--fabric-space-padding-md);
  padding-left: var(--fabric-space-padding-md);
  height: calc(100% - var(--fabric-space-padding-xl));
  overflow-y: hidden;
`;

export const sendInThreadViewStyles = css`
  display: flex;
  flex-direction: column;
  border-top-left-radius: var(--fabric-radius-md);
  border-top-right-radius: var(--fabric-radius-md);
  border-bottom-right-radius: var(--fabric-radius-md);
  border-bottom-left-radius: var(--fabric-radius-md);
  border-width: var(--fabric-number-n-0-25);
  border-style: solid;
  border-color: var(--fabric-color-neutral-20);
`;

export const bodyAndSendAreaContainerStyles = css`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const footerContentStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const footerActionsStyles = css`
  display: flex;
  align-items: center;
  row-gap: var(--fabric-space-gap-md);
  column-gap: var(--fabric-space-gap-md);
`;

export const inlineNotificationBorderNoneStyles = css`
  border-style: none;
`;

export const dialogPopoverStyles = css`
  padding-top: var(--fabric-space-padding-xs);
  padding-right: var(--fabric-space-padding-none);
  padding-bottom: var(--fabric-space-padding-xs);
  padding-left: var(--fabric-space-padding-none);
  border-top-left-radius: var(--fabric-radius-sm);
  border-top-right-radius: var(--fabric-radius-sm);
  border-bottom-right-radius: var(--fabric-radius-sm);
  border-bottom-left-radius: var(--fabric-radius-sm);
`;

export const sendButtonStyles = css`
  white-space: nowrap;
`;

export const sendButtonCaretOverrideStyles = css`
  width: auto;
  padding-top: var(--fabric-space-gap-xs);
  padding-right: var(--fabric-space-gap-xs);
  padding-bottom: var(--fabric-space-gap-xs);
  padding-left: var(--fabric-space-gap-xs);
  box-shadow: inset 1px 0 0 0 var(--fabric-color-action-primary-background-pressed);
`;

export const tooltipCenteredStyles = css`
  text-align: center;
`;

export const modalFlexContent = css`
  display: flex;
  flex-direction: column;
  row-gap: var(--fabric-number-n-8);
  column-gap: var(--fabric-number-n-8);
  height: 100%;
`;

export const modalFlexContentSmall = css`
  row-gap: var(--fabric-number-n-6);
  column-gap: var(--fabric-number-n-6);
`;

export const modalBodyFlexContent = css`
  display: flex;
  flex-direction: column;
  row-gap: var(--fabric-number-n-4-rem);
  column-gap: var(--fabric-number-n-4-rem);
  height: 100%;
`;

export const footerContainerStyles = css`
  &.wv-modal-footer {
    padding-top: var(--fabric-space-padding-none);
    padding-right: var(--fabric-space-padding-none);
    padding-bottom: var(--fabric-space-padding-none);
    padding-left: var(--fabric-space-padding-none);
  }
`;

export const headerContainerStyles = css`
  padding-top: var(--fabric-space-padding-none);
  padding-right: var(--fabric-space-padding-none);
  padding-bottom: var(--fabric-space-padding-none);
  padding-left: var(--fabric-space-padding-none);
`;

export const modalHeaderStyles = css`
  padding-top: var(--fabric-space-padding-none);
  padding-right: var(--fabric-space-padding-none);
  padding-bottom: var(--fabric-space-padding-none);
  padding-left: var(--fabric-space-padding-none);
  line-height: var(--fabric-number-n-8-rem);

  /* Override the responsive modal's mobile .wv-modal-header padding (higher specificity) */
  &&.wv-modal-header {
    padding-top: var(--fabric-space-padding-none);
    padding-right: var(--fabric-space-padding-none);
    padding-bottom: var(--fabric-space-padding-none);
    padding-left: var(--fabric-space-padding-none);
  }
`;

export const modalHeaderStylesSmall = css`
  && h2 {
    font-size: var(--fabric-number-n-5);
  }
`;

export const styles = {
  shortenedUrlWiggleStyles,
  modalBodyStyles,
  modalHeaderStyles,
  modalHeaderStylesSmall,
  templateSelectionContainerStyles,
  templateSelectionHeaderStyles,
  templateSelectorStyles,
  sendInThreadViewStyles,
  bodyAndSendAreaContainerStyles,
  footerContentStyles,
  footerActionsStyles,
  inlineNotificationBorderNoneStyles,
  dialogPopoverStyles,
  sendButtonStyles,
  tooltipCenteredStyles,
  sendButtonCaretOverrideStyles,
  modalFlexContent,
  modalFlexContentSmall,
  modalBodyFlexContent,
  footerContainerStyles,
  headerContainerStyles,
};
